import type { ActionLogEntry } from '@tailorcast/shared-types';
import { useRollbackAction } from '../hooks/useActions';

interface RollbackButtonProps {
  action: ActionLogEntry;
}

export function RollbackButton({ action }: RollbackButtonProps) {
  const rollback = useRollbackAction();

  if (action.rollbackStatus !== 'available') {
    return <span className="text-xs text-gray-400 capitalize">{action.rollbackStatus}</span>;
  }

  const deadlineExpired = new Date(action.rollbackDeadline) < new Date();
  if (deadlineExpired) {
    return <span className="text-xs text-gray-400">Expired</span>;
  }

  return (
    <button
      onClick={() => rollback.mutate(action.id)}
      disabled={rollback.isPending}
      className="btn btn-outline text-xs py-1 px-2"
    >
      {rollback.isPending ? 'Rolling back...' : 'Rollback'}
    </button>
  );
}
